import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '../store'
import router from '../router'

// 创建axios实例，替换整个transformResponse数组
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || 'http://localhost:8080/api',
  timeout: 15000,
  // 替换整个transformResponse数组，确保只有我们的自定义解析器执行
  transformResponse: [
    function (data) {
      if (typeof data === 'string') {
        try {
          // 使用JSON.parse的reviver参数处理大整数
          return JSON.parse(data, (key, value) => {
            // 检查是否是数字且超过JavaScript安全整数范围
            if (typeof value === 'number' && !Number.isSafeInteger(value)) {
              return value.toString()
            }
            return value
          })
        } catch (e) {
          return data
        }
      }
      return data
    }
  ]
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = store.getters.token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    // 如果是FormData类型，不设置Content-Type，让浏览器自动处理
    if (config.data instanceof FormData) {
      // 删除手动设置的Content-Type，让浏览器自动添加带边界的Content-Type
      delete config.headers['Content-Type']
    }
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('请求URL:', (config.baseURL || '') + (config.url || ''))
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    if (error.response) {
      const status = error.response.status
      let message = '请求失败'
      try {
        // 处理错误响应中的大整数
        if (typeof error.response.data === 'string') {
          const errorData = JSON.parse(error.response.data, (key, value) => {
            if (typeof value === 'number' && !Number.isSafeInteger(value)) {
              return value.toString()
            }
            return value
          })
          message = errorData.message || '请求失败'
        } else {
          message = error.response.data.message || '请求失败'
        }
      } catch (e) {
        message = error.response.data.message || '请求失败'
      }
      
      if (status === 401) {
        ElMessage.error('登录已过期，请重新登录')
        store.dispatch('logout')
        router.push('/login')
        return Promise.reject(error)
      } else if (status === 403) {
        ElMessage.error('没有权限访问')
      } else if (status === 500) {
        ElMessage.error('服务器错误，请稍后再试')
      } else {
        ElMessage.error(message)
      }
    } else {
      ElMessage.error('网络错误，请检查网络连接')
    }
    return Promise.reject(error)
  }
)

export default service